import {combineReducers} from 'redux';

import type {Events as SchedulerEventsState} from 'src/types/scheduler/events';
import type {SchedulerDashboardState} from './dashboard';
import type {SchedulerSettingsState} from './settings';
import type {Holidays} from 'src/types/scheduler/holidays';

import type {SchedulerOrgTemplatesState} from 'src/types/scheduler/org-templates.js';

import type {SchedulerTemplatesState} from 'src/types/scheduler/templates';

import type {SchedulerGlobalState} from './global';

import type {SchedulerTemplateForm} from 'src/types/scheduler/template-form';
import type {SmartSchedulerState} from './smart-scheduler';

import {default as events} from './events';
import {default as dashboard} from './dashboard';
import {default as settings} from './settings';
import {default as templates} from './templates';
import {default as holidays} from './holidays';
import {default as global} from './global';
import {default as templateForm} from './template-form';
import {default as orgTemplates} from './org-templates';
import {default as smartScheduler} from './smart-scheduler';


export type State = {
  events: SchedulerEventsState;
  dashboard: SchedulerDashboardState;
  settings: SchedulerSettingsState;
  templates: SchedulerTemplatesState;
  holidays: Holidays;
  global: SchedulerGlobalState;
  templateForm: SchedulerTemplateForm;
  orgTemplates: SchedulerOrgTemplatesState;
  smartScheduler: SmartSchedulerState;
};

const reduce = combineReducers({
  events,
  dashboard,
  settings,
  templates,
  holidays,
  orgTemplates,
  global,
  templateForm,
  smartScheduler,
});

export default reduce;
